import React from "react";
import { useParams } from 'react-router-dom';


import ProductDetails from "../Components/ProductDetails";

export default function ProductPage() {
  const { id } = useParams();
  return (
    <div className="light-section w-100 pt-4">
      <div className="container main-content-padding pt-0">
        <ProductDetails productId={id} />
      </div>
    </div>
  );
}
